import { render, staticRenderFns } from "./Attacks.vue?vue&type=template&id=2f622a71&scoped=true&"
import script from "./Attacks.vue?vue&type=script&lang=js&"
export * from "./Attacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f622a71",
  null
  
)

export default component.exports